import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { mediaSrc } from "@/lib/api";

const DEFAULT_VIDEO = "/media/river_50573.mp4";
// Each step drifts the camera a little deeper into the forest
const JOURNEY = {
  1: "scale(1.04) translate3d(0,0,0)",
  2: "scale(1.12) translate3d(-1.5%,1%,0)",
  3: "scale(1.2) translate3d(1.5%,2%,0)",
  4: "scale(1.3) translate3d(0,3%,0)",
};

export default function BackgroundStage() {
  const { settings, state } = useApp();
  const { pathname } = useLocation();
  const videoRef = useRef(null);
  const src = mediaSrc(settings?.media?.video) || DEFAULT_VIDEO;
  const step = pathname === "/" ? state.step : 1;

  useEffect(() => {
    videoRef.current?.play().catch(() => {});
  }, [src]);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden bg-[#06120e] grain" aria-hidden="true">
      {settings && (
        <video
          key={src}
          ref={videoRef}
          data-testid="background-video"
          className="absolute inset-0 h-full w-full object-cover"
          style={{ transform: JOURNEY[step] || JOURNEY[1], transition: "transform 3.2s cubic-bezier(.22,.61,.36,1)" }}
          src={src}
          autoPlay
          muted
          loop
          playsInline
        />
      )}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 30% 20%, rgba(6,18,14,0.15), rgba(6,18,14,0.55) 60%, rgba(4,12,9,0.85) 100%)",
        }}
      />
    </div>
  );
}
